import {
  Article,
  Build,
  Campaign,
  Cancel,
  CheckCircle,
  Description,
  Download,
  Error,
  Event,
  FilePresent,
  History,
  Info,
  Lightbulb,
  NewReleases,
  NotificationsActive,
  PriorityHigh,
  Schedule,
  Settings,
  Update,
  Upload,
  Warning,
  WarningAmber,
} from '@mui/icons-material';

export const ALERT_ICONS = {
  // Status & Severity
  info: { icon: Info, label: 'Info' },
  warning: { icon: Warning, label: 'Warning' },
  warningAmber: { icon: WarningAmber, label: 'Caution' },
  error: { icon: Error, label: 'Error' },
  success: { icon: CheckCircle, label: 'Success' },
  cancel: { icon: Cancel, label: 'Blocked/Denied' },
  // Documents
  description: { icon: Description, label: 'Document' },
  article: { icon: Article, label: 'Article' },
  filePresent: { icon: FilePresent, label: 'File' },
  upload: { icon: Upload, label: 'Upload' },
  download: { icon: Download, label: 'Download' },
  // Time & Scheduling
  schedule: { icon: Schedule, label: 'Deadline' },
  event: { icon: Event, label: 'Event' },
  update: { icon: Update, label: 'Update' },
  history: { icon: History, label: 'History' },
  // Features & System
  newReleases: { icon: NewReleases, label: 'New Release' },
  campaign: { icon: Campaign, label: 'Campaign' },
  build: { icon: Build, label: 'Maintenance' },
  settings: { icon: Settings, label: 'Settings' },
  lightbulb: { icon: Lightbulb, label: 'Tip' },
  // Actions & Attention
  notificationsActive: { icon: NotificationsActive, label: 'Alert' },
  priorityHigh: { icon: PriorityHigh, label: 'Urgent' },
} as const;

export type AlertIconKey = keyof typeof ALERT_ICONS;
